import { Component, Input, ChangeDetectionStrategy} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
  selector: 'app-common-modal',
  templateUrl: './common-modal.component.html',
  styleUrls: ['./common-modal.component.scss']
})
export class CommonModalComponent {
  @Input() title: string = 'Confirmation';
  @Input() bodyText: string;
  @Input() cancelText: string = 'Cancel';
  @Input() okText: string = 'Ok';
  @Input() showCancel: boolean = true;
  @Input() showCrossIcon: boolean = true;

  constructor(public activeModal: NgbActiveModal) { }

}
